import { type JSX } from 'react';
import type { SkeletonCardProps } from './SkeletonCard/SkeletonCard.types';

export interface SkeletonOptions {
  paddingBottom?: string;
  paddingBetween?: string;
  className?: string;
  cardProps?: SkeletonCardProps;
}

export type ItemSkeletonFunction = (props?: SkeletonCardProps) => JSX.Element;
export type ColumnSkeletonFunction = (
  count?: number,
  options?: SkeletonOptions
) => JSX.Element;

export enum SkeletonType {
  PRODUCT_CARD = 'ProductCard',
  LIST = 'List',
  SEARCH = 'Search',
  DOUBLE_COLUMN = 'DoubleColumn',
  TRIPLE_COLUMN = 'TripleColumn',
  CURATION_CARD = 'CurationCard',
  CUSTOM = 'custom',
  PDP = 'PDP',
}
